import { z } from "zod";

export const updateTripAddressesPayloadSchema = z.object({
  tripUuid: z.uuid(),
});

export type UpdateTripAddressesPayload = z.infer<
  typeof updateTripAddressesPayloadSchema
>;
